import {
  CartellaDto,
  CartelleProcedimentoAreaPubblicaDto,
  FileCartellaDto,
} from '@framework/api-client';

export interface IPublicAreaFile extends FileCartellaDto {
  type: 'file';
}

export interface IPublicAreaFolder extends CartellaDto {
  type: 'folder';
  children?: IPublicAreaFile[];
}

export type IPublicAreaItem = IPublicAreaFile | IPublicAreaFolder;

export function getTableTreeDataFromCartelle(
  data?: CartelleProcedimentoAreaPubblicaDto,
): IPublicAreaItem[] {
  return (
    data?.dati?.map(folder => ({
      type: 'folder',
      nome: folder.nome ?? 'N/A',
      id: folder.id + '/folder',
      // altri dati che non sono presenti in una cartella ma uniamo
      // per avere un'unica struttura nella tabella
      tipo: '',
      numeroProtocollo: '',
      dataProtocollo: '',
      dataDocumento: '',
      descrizione: '',
      formato: '',
      dimensione: '',
      url: '',
      // i file passati come children per AntTable
      children: folder.file?.map(file => ({
        type: 'file',
        ...file,
      })),
    })) ?? []
  );
}
